
import Vue from 'vue'
import i18n from './i18n'
import OrgSunsetWarningBanner from '@/components/OrgSunsetWarningBanner.vue'

export default Vue.extend({
  components: { OrgSunsetWarningBanner },
  computed: {
    organizationColor(){
      return this.$store.getters.organizationColor
    }
  },
  beforeMount(){
    i18n.locale = 'de' // TODO: Allow to change this dynamically
  },
  watch: {
    '$route'(to, from){
      // Adjust app title and color from brand
      document.title = this.$store.getters.organizationName || "Ligurio"
      document.querySelector("meta[name=theme-color]")?.setAttribute("content", this.$store.getters.organizationColor)
    }
  }
})
